module.exports = require('./helpers/bundle-url').getBundleURL('lORN7') + "marker-icon.61a78335.png" + "?" + Date.now();